import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import {
  NumberField,
  SelectField,
  useRecordContext,
} from 'react-admin';

import { unitsOfTimeChoices } from '../../../constants/unitsOfTime';
import { dueDiligenceDateToTrackChoices } from '../../../constants/dueDiligenceDatesToTrack';

const DueDiligence = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <Grid
      alignItems="baseline"
      size={{
        xs: 12,
        sm: 6,
        lg: 4,
      }}
    >
      <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
        <Typography fontWeight="bold" fontSize={10}>
          Date to track
        </Typography>
        <SelectField
          choices={dueDiligenceDateToTrackChoices}
          source="ruleParameters.dateToTrack"
          fontSize={10}
        />

        <Typography fontWeight="bold" fontSize={10}>
          Default threshold
        </Typography>
        <NumberField
          source="ruleParameters.defaultThreshold"
          fontSize={10}
        />

        <Typography fontWeight="bold" fontSize={10}>
          Unit of time
        </Typography>
        <SelectField
          choices={unitsOfTimeChoices}
          source="ruleParameters.unitOfTime"
          fontSize={10}
        />
      </Box>
    </Grid>
  );
};

export default DueDiligence;
